/**
 * A short label with a tone: the state of an instance, the connection of a server, the outcome of
 * a phase. `tone` is one of the tones of i18n/labels.js; `pulse` marks something in progress.
 */
import { LitElement, html } from 'lit';

import { customerStateOf } from '../i18n/customer-labels.js';
import { CONNECTION, PHASE_STATUS, REVISION_STATUS, SERVER_STATUS, stateOf } from '../i18n/labels.js';
import { planeBadgeStyles } from '../../styles/components/plane-badge.js';

class PlaneBadge extends LitElement {
  static properties = {
    tone: { type: String, reflect: true },
    pulse: { type: Boolean, reflect: true },
  };

  static styles = planeBadgeStyles;

  render() {
    return html`<slot></slot>`;
  }
}

customElements.define('plane-badge', PlaneBadge);

/** The displayed state of an instance, with its explanation as a tooltip. */
export const stateBadge = (code) => {
  const state = stateOf(code);
  return html`<plane-badge tone=${state.tone} ?pulse=${code === 'updating'} title=${state.hint}>${state.label}</plane-badge>`;
};

export const connectionBadge = (code) => {
  const connection = CONNECTION[code] ?? CONNECTION.never;
  return html`<plane-badge tone=${connection.tone}>${connection.label}</plane-badge>`;
};

export const serverStatusBadge = (code) => {
  const status = SERVER_STATUS[code] ?? { label: code, tone: 'muted' };
  return html`<plane-badge tone=${status.tone}>${status.label}</plane-badge>`;
};

export const phaseStatusBadge = (code) => {
  const status = PHASE_STATUS[code] ?? { label: code, tone: 'muted' };
  return html`<plane-badge tone=${status.tone} ?pulse=${code === 'started'}>${status.label}</plane-badge>`;
};

export const revisionStatusBadge = (code) => {
  const status = REVISION_STATUS[code] ?? { label: code, tone: 'muted' };
  return html`<plane-badge tone=${status.tone}>${status.label}</plane-badge>`;
};

/** The displayed state of an instance, as the customer pages say it. */
export const customerStateBadge = (code) => {
  const state = customerStateOf(code);
  return html`<plane-badge tone=${state.tone} ?pulse=${code === 'updating'}>${state.label}</plane-badge>`;
};
